import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signup from "./Pages/Signup/Signup";
import Signin from "./Pages/Signin/Signin";
import Accounts from "./Pages/Accounts/Accounts";
import Dashboard from "./Pages/Dashboard/Dashbord";
import Transactions from "./Pages/Transactions/Transactions";
import Home from "./Pages/Home/Home";
import Landing from "./Pages/Landingpage/Landing";
import Settings from "./Pages/Settings/settings.js";
import OrganizationSettings from "./Pages/Settings/OrganizationSettings";
import AddCompany from "./Pages/Settings/AddCompany";
import Optverify from "./Pages/Optverify/Optverify";
import Sections from "./Pages/Sections/Sections";
import Pricing from "./Pages/Pricing/Pricing";

import Receipts from "./Pages/Receipts/Receipts";
import Lodgement from "./Pages/Lodgement/Lodgement";
import Charting from "./Pages/Charting/Charting";
import Payments from "./Pages/Payments/Payments";
import Payables from "./Pages/Payables/Payables";
import Payment from "./Pages/Payment/Payment";
import PettyCash from "./Pages/PettyCash/PettyCash";
import Sales from "./Pages/Sales/Sales";
import Business from "./Pages/Business/Business";
import Reportss from "./Pages/Reportss/Reportss";
import Receivables from "./Pages/Receivables/Receivables";
import Purchaseinvoice from "./Pages/Purchaseinvoice/Purchaseinvoice";
import Generalledger from "./Pages/Generalledger/Generalledger";
import BankRecon from "./Pages/BankRecon/BankRecon";
import BankBank from "./Pages/BankRecon/BankBankRecon";
import Onboarding from "./Pages/Onboard/Onboard";
import Onboardingcopy from "./Pages/Onboard/Onboarding";
import Customers from "./Pages/Customers/Customers";
import Report from "./Pages/Reports/Report";
import BalanceSheetReport from "./Pages/BalanceSheetReport/BalanceSheetReport";
import CashFlowStatement from "./Pages/CashFlowStatement/CashFlowStatement";
import TrialBalance from "./Pages/TrialBalance/TrialBalance";
import Suppliers from "./Pages/Suppliers/Suppliers";
import ActionPage from "./Pages/ActionPage/ActionPage";
import Prchasing from "./Pages/Prchasing/Prchasing";
import Invoicedate from "./Pages/Invoicedate/Invoicedate";
import ListofAccount from "./Pages/ListofAccount/ListofAccount";
import NewItem from "./Pages/Purchaseinvoice/NewItem";
import Reportinvoice from "./Pages/Reportinvoice/Reportinvoice";
import Newitemproducts from "./Pages/Newitemproducts/Newitemproducts";
import MakeSale from "./Pages/Make sale/MakeSale";
import Preview from "./Pages/Invoice Preview/Preview";
import Previeww from "./Pages/CashManage/Previeww/Previeww.js";
import InvoiceDateReciptNew from "./Pages/InvoiceDateReciptNew/InvoiceDateReciptNew";
import PurchaseOrder from "./Pages/Inventory/PurchaseOrder/PurchaseOrder";
import NewPayables from "./Pages/Supplier Payables/Newpayable/Newitemproducts";
import SupplierPayables from "./Pages/Supplier Payables/Payables";
import Sale from "./Pages/Make sale/Sale";
import StockDelivary from "./Pages/StockDelivary/StockDelivary";
import NewPayment from "./Pages/Purchaseinvoice/NewPayment";
import NewPaymentPage from "./Pages/Purchaseinvoice/NewPaymentPage";
import ManageUser from "./Pages/ManageUser/ManageUser";
import ManageStore from "./Pages/ManageUser/ManageStore";
import PosReceipt from "./Pages/InvoiceDateReciptNew/PosReceipt";
import PrintRecipt from "./Pages/PrintRecipt/PrintRecipt";
import ReceiptPrintPreview from "./Pages/Receipts/PrintRecipt/PrintRecipt";
import CustomerSales from "./Pages/Customer Sales/CustomerSales";
import Actionpaged from "./Pages/ActionPaged/ActionPaged";
import PrintSalesReceipt from "./Pages/InvoiceDateReciptNew/PrintSalesReceipt";
import Managelocation from "./Pages/ManageUser/managelocation";
import ChangePassword from "./Pages/ChangePassword/ChangePassword"
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import NewPassword from "./Pages/NewPassword/NewPassword"
import Managecurrency from "./Pages/Managecurrency/Managecurrency.js"
import CustomerPersonalLedger from "./Pages/Customer Sales/PersonalLedger.js"
import EmployeePersonalLedger from "./Pages/Loan Allocated/PersonalLedger.js"
import ChartLedger from "./Pages/Charting/ChartlLedger.js";
import SupplierLedger from "./Pages/SuppliersLedger/SuppliersLedger.js";
import SupplierPersonalLedger from "./Pages/SuppliersLedger/SuppliersPersonalLedger.js";
import MakeJournal from "./Pages/Generalledger/Make sale/MakeJournal.js";
import Journal from "./Pages/Generalledger/Journal/Journal.js";
import GeneralLedgerStatement from "./Pages/Reports/GeneralLedger report/GeneralLedgerStatement.jsx";
import EcobankCheque from "./Pages/EcobankCheque.jsx";
import EcobankChequeTemp from "./Pages/Cheque/EcobankChequeTemp.jsx";
import FundWallet from "./Pages/Wallet/FundWallet";
import WalletDetails from "./Pages/Wallet/WalletDetails";
import CreateOrder from "./Pages/CreateOrder/CreateOrder.js";
import RequestForm from "./Pages/RequestForm/RequestForm.js";
import FinishedGoods from "./Pages/FinishedGoods/FinishedGoods.js";
import MaterialIssued from "./Pages/MaterialIssued/MaterialIssued.js";
import CashManage from "./Pages/CashManage/CashManage.js"
import BankPayment from "./Pages/BankingPayment/Payment.js";
import Balance from "./Pages/Balance/Balance.js";
import PaymentReceipt from "./Pages/BankingPayment/PaymentReceipt/PaymentReceipt.js";
import PaymentVoucher from "./Pages/BankingPayment/PaymentVoucher/PaymentVoucher.js";
import EmployeeRecord from "./Pages/Employee Payroll/EmployeeRecord.js";
import SalaryStructure from "./Pages/Salary Structure/Salarystructure.js";
import SetupDeduction from "./Pages/Salary Structure/Setup Deduction/Deduction.js";
import MonthlyDeduction from "./Pages/Salary Structure/Monthly Deduction/Deduction.js";
import SetupAllowance from "./Pages/Salary Structure/Setup Allowance/Allowance.js";
import Payslip from "./Pages/Pay Slip/Payslip.js";
import PayslipReciept from "./Pages/Pay Slip/PaymentVoucher/PaymentVoucher.js";
import MonthlySalaryCompetition from "./Pages/Monthly Salary competition/PaymentVoucher/PaymentVoucher.js";
import ComputationPayslipReciept from "./Pages/Monthly Salary competition/Payroll/PaymentVoucher.js";
import Login from "./Pages/Login/Logn.js";
import InviteResponse from "./Pages/InviteResponse";
import BusinessSetup from "./Pages/Business Setup/BusinessSetup.js";
import OnboardOTP from "./Pages/Onboarding OTP/OnboardOTP.js";
import PricingNew from "./Pages/Pricing New/PricingNew.js";
import PricingNewPayment from "./Pages/Pricing New payment/PricingNewPayment.js";
import WitholdingTaxPayable from "./Pages/Witholding Tax Payable/WitholdingTaxPayable.js";
import PayePayable from "./Pages/PAYE Payable/PayePayable.js";
import VatPayable from "./Pages/Value Added Tax Payable/VatPayable.js";
import PensionPayable from "./Pages/Pension Payable/PensionPayable.js";
// import BankPayments from "./Pages/BankingPayment/Payment.js";
import BankPaymentsrcpt from "./Pages/BankingPayment/Payment.js";
import AssetCategory from "./Pages/AssetCategory/AssetCategory.js";
import FixedAsset from "./Pages/FixedAsset/FixedAsset.js";
import AssetLocation from "./Pages/AssetLocation/AssetLocation.js";
import AssetAssignment from "./Pages/AssetAssignment/AssetAssignment.js";
import AssetDepriciation from "./Pages/AssetDepriciation/AssetDepriciation.js";
import AssetRevaluation from "./Pages/AssetRevaluation/AssetRevaluation.js";
import AssetDisposal from "./Pages/AssetDisposal/AssetDisposal.js";
import AssetMaintainance from "./Pages/AssetMaintainance/AssetMaintainance.js";
import AssetMovement from "./Pages/AssetMovement/AssetMovement.js";
import AssetDocuments from "./Pages/AssetDocuments/AssetDocuments.js";
import UploadBasicSalary from "./Pages/Upload Basic Salary/UploadBasicSalary.jsx";
import PayePayment from "./Pages/BankingPayment/PayePayment.js";
import WitholdingTaxPayment from "./Pages/Witholding Tax Payment/WitholdinTaxPayment.js";
import AddProduct from "./Pages/Settings/AddProducts.js";
import LoanPayment from "./Pages/LoanPayment/LoanPayment.js";
import LoanRequest from "./Pages/LoanPayment/LoanRequest/LoanRequest.js";
import Manageloans from "./Pages/ManageUser/manageloans.js";
import LoanAllocated from "./Pages/Loan Allocated/LoanAllocated.js";
import JournalSearch from "./Pages/Generalledger/Journal Search/JournalSearch.js";
import ManageIndustry from "./Pages/ManageIndustry/ManageIndustry.js";
import ChartOfAccount from "./Pages/Chart of Account/ChartOfAccount.js";
import UploadOpeningBal from "./Pages/Chart of Account/UploadOpeningBal.js";
import ConfirmOpeningBal from "./Pages/Chart of Account/ConfirmOpeningBal.js";
import ManualOpeningBal from "./Pages/Chart of Account/ManualOpeningBal.js";
import ReconciliationLedger from "./Pages/Reconciliation/BankBankRecon.jsx";
import BankStatement from "./Pages/Bank Statement/BankSatatement.jsx";
import BankStatementPreview from "./Pages/Bank Statement Preview/BankStatementPreview.jsx";
import ChartofAccountPreview from "./Pages/Dashboard/Components/DashboardHeader/Chart of account Preview/ChartofAccountPreview.jsx";
import Managerole from "./Pages/ManageUser/managerole.js";
import Managedepartment from "./Pages/ManageUser/managedepartment.js";
import StockRequisition from "./Pages/Inventory/Stock Requisition/PurchaseOrder.js";
import Managerequisition from "./Pages/Manage requisition/Prchasing.js";
import StockReceived from "./Pages/StockReceived/StockReceived.jsx";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/transactions/receivables/customer-sales" element={<CustomerSales />} />
        <Route path="/transactions/loan-allocated" element={<LoanAllocated />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/fixed_assets/assetcategory" element={<AssetCategory/>} />
        <Route path="/fixed-assets/assetmovement"element={<AssetMovement/>} />
        <Route path="/fixed_assets/assetrevaluation" element={<AssetRevaluation/>} />
        <Route path="/fixed_assets/assetlocation" element={<AssetLocation/>} />
        <Route path="/fixed_assets/assetdisposal" element={<AssetDisposal/>} />
        <Route path="/fixed-assets/assetdocuments" element={<AssetDocuments/>} />
        <Route path="/fixed_assets/assetmaintainance" element={<AssetMaintainance/>} />
        <Route path="/fixed_assets/assetassignment" element={<AssetAssignment/>} />
        <Route path="/fixed_assets/assetdepreciation" element={<AssetDepriciation/>} />
        <Route path="/fixed_assets/fixedasset" element={<FixedAsset/>} />
        <Route path='/transactions/payables/supplier-ledger' element={<SupplierLedger />} />
        <Route path='/transactions/payables/supplier-personal-ledger' element={<SupplierPersonalLedger />} />
        <Route path="/transactions/newactionn" element={<Actionpaged />} />
        <Route path="/settings/change-password" element={<ChangePassword />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/modules/Accounting/Dashboard' element={<Dashboard />} />
        <Route path='/customer-personal-ledger' element={<CustomerPersonalLedger />} />
        <Route path='/employee-personal-ledger' element={<EmployeePersonalLedger />} />
        <Route path='/Chart-ledger' element={<ChartLedger />} />
        <Route path='/payment-receipt' element={<PaymentReceipt />} />
        <Route path='/loan-request' element={<LoanRequest />} />
        <Route path='/modules' element={<Sections />} />
        <Route path='/home' element={<Home />} />
        <Route path='/settings/product-services' element={<Settings />} />
        <Route path='/settings/organization' element={<OrganizationSettings />} />
        <Route path='/settings/add-company' element={<AddCompany />} />
        <Route path='/transactions/receivables/sales' element={<Transactions />} />
        <Route path='/transactions/receivables/customers' element={<Customers />} />
        <Route path='/transactions/payables/suppliers' element={<Suppliers />} />
        <Route path='/transactions/payables/payables' element={<Payables />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/modules" element={<Sections />} />
        <Route path="/home" element={<Home />} />
        <Route path="/landing" element={<Landing />} />
        {/* <Route path="/settings/product-services" element={<Settings />} /> */}
        {/* <Route path="/transactions/sales-invoice" element={<Transactions />} /> */}
        <Route path="/transactions/newaction" element={<ActionPage />} />
        <Route path="/report/general-ledger" element={<GeneralLedgerStatement />} />
        <Route path="/transactions/cashReciept" element={<CashManage />} />
        <Route path="/accounting/cashmanage/cashReciept" element={<CashManage />} />
        <Route path="/reports/balancebroughtforward" element={<Balance />} />

        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<Landing />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/business" element={<Business />} />
        <Route path="/business-setup" element={<BusinessSetup />} />
        <Route path="/otpverification" element={<Optverify />} />
        <Route path="/onboarding-otp" element={<OnboardOTP />} />
        <Route path="/optverification" element={<Optverify />} />
        <Route path="/home" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/pricing-new" element={<PricingNew />} />
        <Route path="/pricing-new-payment" element={<PricingNewPayment />} />
        <Route path="/chart-of-account" element={<ChartOfAccount />} />
        <Route path="/upload-opening-bal" element={<UploadOpeningBal />} />
        <Route path="/confirm-opening-bal" element={<ConfirmOpeningBal />} />
        <Route path="/manual-opening-bal" element={<ManualOpeningBal />} />
        <Route path="/sales" element={<Sales />} />
        <Route
          path="/transactions/payables/purchase" element={<Purchaseinvoice />}
        />
        <Route path="/transactions/witholding-tax-payable" element={<WitholdingTaxPayable />} />
        <Route path="/transactions/paye-payable" element={<PayePayable />} />
        <Route path="/transactions/pension-payable" element={<PensionPayable />} />
        <Route path="/transactions/vat-payable" element={<VatPayable />} />
        {/* <Route path="/transactions/receipts" element={<Receipts />} /> */}
        <Route path="/transactions/receipts" element={<Receipts />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/reports/charting" element={<Charting />} />
        <Route path="/reports/wht-payment" element={<WitholdingTaxPayment />} />
        {/* <Route path="/transactions/payables" element={<Payables />} /> */}
        <Route path="/transactions/sales-invoice/receivables" element={<Receivables />} />
        <Route path="/payroll/upload-basic-salary" element={<UploadBasicSalary />} />
        <Route path="/reports/generalledger" element={<Generalledger />} />
        <Route path="/transactions/pettycash" element={<PettyCash />} />
        {/* <Route path="/transactions/payment" element={<Payment />} /> */}
        <Route path="/transactions/payment" element={<NewPaymentPage />} />
        <Route path="/transactions/payment/new_payment" element={<NewPayment />} />
        <Route path="/transactions/lodgement" element={<Lodgement />} />
        <Route path="/inventory/PurchaseOrder" element={<PurchaseOrder />} />
        <Route path="/inventory/StockRequisition" element={<StockRequisition />} />
        <Route path="/inventory/manageRequisition" element={<Managerequisition />} />
        {/* <Route path="/inventory/purchase_order" element={<PurchaseOrder />} /> */}
        <Route path="/inventory/supplier_payables" element={<SupplierPayables />} />
        <Route path="reportss" element={<Reportss />} />
        <Route path="/bankreconcillation" element={<BankRecon />} />
        {/* <Route path="/accounting/banksreconcillation" element={<BankBank />} /> */}
        <Route path="/accounting/banksreconcillation" element={<ReconciliationLedger />} />
        <Route path="/accounting/bankstatement" element={<BankStatement />} />
        <Route path="/accounting/bankstatement-preview" element={<BankStatementPreview />} />
        <Route path="/accounting/chartofaccount-preview" element={<ChartofAccountPreview />} />
        <Route path="/fixed-assets/banksreconcillation" element={<BankBank />} />
        <Route path="/transactions/sales-pos/makesale" element={<MakeSale />} />
        <Route path="/transactions/sales-pos" element={<Sale />} />
        <Route path="/accounting/journalentry/new-journal-entry" element={<MakeJournal />} />
        <Route path="/accounting/journalentry/journal-entry" element={<Journal />} />
        <Route path="/accounting/journalentry/journal-search" element={<JournalSearch />} />
        <Route path="/inventory/workProgress/createOrder" element={<CreateOrder />} />
        <Route path="/inventory/workProgress/rawMaterial" element={<RequestForm/>} />
        <Route path="/inventory/workProgress/finishedGoods" element={<FinishedGoods/>} />
        <Route path="inventory/workProgress/materialsending" element={<MaterialIssued/>} />

        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/onboarding_dup" element={<Onboardingcopy />} />
        <Route path="/report/financial-statements" element={<Report />} />
        <Route path="/listofaccount" element={<ListofAccount />} />
        <Route path="/balancesheet" element={<BalanceSheetReport />} />
        <Route path="/cashflow" element={<CashFlowStatement />} />
        <Route path="/reports/trailbalance" element={<TrialBalance />} />
        <Route path="/reportss" element={< Reportss />} />
        <Route path="/transactions/purchase-invoice/purchase/new-item" element={<NewItem />} />
        <Route path="/reportinvoice" element={<Reportinvoice />} />
        <Route path="/invoice-preview" element={<Preview />} />
        <Route path="/invoice-previeww" element={<Preview />} />
        <Route path="/preview" element={<Previeww />} />
        <Route path="/invoicedate" element={<Invoicedate />} />
        <Route path="/invoicedaterecipt" element={<InvoiceDateReciptNew />} />
        <Route path="/printreceipts" element={<PrintRecipt />} />
        <Route path="/print-customer-receipt" element={<ReceiptPrintPreview />} />
        <Route path="/print_sales_recepits" element={<PrintSalesReceipt />} />
        <Route path="/inventory/prchasing" element={<Prchasing />} />
        <Route path="/settings/products&services/new-items/newitemproducts" element={<Newitemproducts />} />
        <Route path="/settings/products&services/new-items/add-product" element={<AddProduct />} />
        <Route path="/inventory/supplier_payables/new-payables" element={<NewPayables />} />
        <Route path="/inventory/stocks_delivery" element={<StockDelivary />} />
        <Route path="/inventory/stocks_received" element={<StockReceived />} />
        <Route path="/settings/manage-user" element={<ManageUser />} />
        <Route path="/settings/manage-store" element={<ManageStore />} />
        <Route path="/pos_receipt" element={<PosReceipt />} />
        <Route path="/pos_receipt" element={<PosReceipt />} />
        <Route path="/settings/manage-location" element={<Managelocation />} />
        <Route path="/settings/manage-loans" element={<Manageloans />} />
        <Route path="/settings/manage-role" element={<Managerole />} />
        <Route path="/settings/manage-department" element={<Managedepartment />} />
        <Route path="/settings/manage-currency" element={<Managecurrency />} />
        <Route path="/settings/manage-industry" element={<ManageIndustry />} />
        <Route path="/newpassword" element={<NewPassword />} />
        <Route path="/cheque" element={<EcobankCheque />} />
        <Route path="/cheque_temp" element={<EcobankChequeTemp />} />
        <Route path="/banking_payment" element={<BankPayment />} />
        <Route path="/fixed_assets/payment" element={<BankPayment />} />
        <Route path="/wallet" element={<WalletDetails />} />
        <Route path="/wallet/fund" element={<FundWallet />} />
        {/* <Route path="/accounting/payment" element={<BankPayment />} /> */}
        <Route path="/transactions/bank-payments" element={<BankPaymentsrcpt />} />
        <Route path="/transactions/paye-payments" element={<PayePayment />} />
        <Route path="/transactions/loan-payments" element={<LoanPayment />} />
        <Route path="/payment-voucher" element={<PaymentVoucher />} />

         <Route path="/payroll/employee-record" element={<EmployeeRecord />} />
         <Route path="/payroll/salary-structure" element={<SalaryStructure />} />
         <Route path="/payroll/setup-deduction" element={<SetupDeduction />} />
         <Route path="/payroll/monthly-deduction" element={<MonthlyDeduction />} />
         <Route path="/payroll/setup-allowance" element={<SetupAllowance />} />
         <Route path="/reports/payslip" element={<Payslip />} />
         <Route path="/payslip-reciept" element={<PayslipReciept />} />
         <Route path="/payroll/monthly-salary-competition" element={<MonthlySalaryCompetition />} />
         <Route path="/payroll/monthly-salary-competition-slip" element={<ComputationPayslipReciept />} />
         <Route path="/invite-response" element={<InviteResponse />} />

      </Routes>
    </Router>
  );
}

export default App;
